import React from 'react';
import { useNavigate } from 'react-router-dom';

import Panel from '../../components/Panel';
import Image from '../../assets/svg/panelImage.svg';
import Button from '../../components/Button';
import Typography from '../../components/Typography';

const ResendEmail = () => {
  const navigate = useNavigate();

  return (
    <>
      <Panel
        description=""
        title="Como alterar o email cadastrado"
        image={Image}
        panelType="confirmation"
        className="panel-update-email max-md:mb-0"
      >
        <Typography as="p" variant="body2" className="mb-6">
          Entre em contato com nossa equipe de suporte para solicitar a alteração do e-mail
          cadastrado.
        </Typography>
      </Panel>
      <div className="flex flex-col gap-6 items-center justify-center mb-16 md:mb-28 px-[15px] md:px-0">
        <div className="w-full max-w-[470px]">
          <Button
            variant="primary"
            text="Ok, entendi"
            type="button"
            onClick={() => navigate('/resend-email', { replace: true })}
          />
        </div>
        <a
          href="/resend-email"
          className="block text-center mb-6 text-support2-medium font-bold text-sm md:hidden"
        >
          Voltar
        </a>
      </div>
    </>
  );
};

export default ResendEmail;
